import { apiRequestToken } from '../Utilidades/apiRequest';
import { RolProps } from '../interfaces/rolesInterfaces';

export const getRoles = async () => {
    return apiRequestToken({
        endpoint: 'roles',
        method: 'GET',
    })
};

export const getRol = async (id: String) => {
    return apiRequestToken({
        endpoint: `roles/${id}`,
        method: 'GET',
    })
};

export const deleteRol = async (id: number) => {
    return apiRequestToken({
        endpoint: `roles/${id}`,
        method: 'DELETE',
    })
};

export const postRol = async (rol: RolProps) => {
    return apiRequestToken({
        endpoint: 'roles/',
        body: rol,
        method: 'POST',
    })
};